import {useContext} from 'react';
import React from 'react';
import {defineMessage} from 'react-intl';
import {AccessControlIndicator, defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';
import {Button} from '@igp/shared/components/button';
import {ModalContext} from '@igp/shared/components/modal';

import {groups, withAccessCheck} from '@access-control';

import {AdjustDebtModal} from './AdjustDebtModal';

const label = defineMessage({
    id: 'AdjustDebtButton_label',
    defaultMessage: 'Adjust Debt',
});

function AdjustDebtButtonInner() {
    const {openModal} = useContext(ModalContext);

    return (
        <Button
            label={label}
            onClick={() =>
                openModal({
                    body: <AdjustDebtModal />,
                })
            }
        />
    );
}

const adjustDebtButtonResource = defineAccessControlledResource({
    name: 'AdjustDebtButton',
    rules: new GroupAccessRule([groups.adminsGroup]),
});

export const AdjustDebtButton = withAccessCheck(AdjustDebtButtonInner, adjustDebtButtonResource, AccessControlIndicator.Hidden);
